//Spinner Component

import React from "react";

const Spinner = () => (
  <div className="flex justify-center items-center h-64">
    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-green-700"></div>
  </div>
);

export default Spinner;
